import { IconChainIntelligence } from '~/icons';
import { Spinner } from '~/components';

import css from './LoadingScreen.module.css';

export const LoadingScreen = () => {
  return (
    <div className={css.screen}>
      <IconChainIntelligence />
      <Spinner style={{ position: 'absolute', marginTop: 150 }} />
    </div>
  );
};
